module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoVolibol-dbf0579f.jpg";